export default class Builder extends Worker {
  constructor(worker:Worker) {
    super(URL.createObjectURL(new Blob([`(${worker.toString()})()`])));
  }
}
